import type { VoidFunctionComponent } from 'react';
import styles from '../../ReportGenerationV2.module.less';
import SidebarNav from '../../../../../generic/SidebarNav';
import type { ReportCategory } from '../../../shared/types';
import { useCanDisplaySecurityOptions } from '../../../hooks';
import { useLocation } from '../../../../../../contexts/RouterContext';

type Props = {
  reportType: ReportCategory | 'settings';
  url: string;
  resetFormat: () => void;
};

const Sidebar: VoidFunctionComponent<Props> = ({ url, reportType, resetFormat }: Props) => {
  const shouldDisplayVulnReport = useCanDisplaySecurityOptions();
  const location = useLocation();
  const isSettingsActive = location.pathname.includes('settings');

  return (
    <span className={styles.sidebar}>
      <SidebarNav>
        <SidebarNav.Heading>Reports</SidebarNav.Heading>
        <SidebarNav.Item onClick={resetFormat} isActive={reportType === 'licensing'} to={`${url}/licensing`}>
          Licensing
        </SidebarNav.Item>
        <SidebarNav.Item onClick={resetFormat} isActive={reportType === 'sbom'} to={`${url}/sbom`}>
          SBOM
        </SidebarNav.Item>
        {shouldDisplayVulnReport && (
          <SidebarNav.Item onClick={resetFormat} isActive={reportType === 'vulnerability'} to={`${url}/vulnerability`}>
            Vulnerabilities
          </SidebarNav.Item>
        )}
        <SidebarNav.Item onClick={resetFormat} isActive={isSettingsActive} to={`${url}/settings`}>
          Settings
        </SidebarNav.Item>
      </SidebarNav>
    </span>
  );
};

export default Sidebar;
